import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import axios from 'axios';
import { setupAxios } from "./helper/axiosInterceptor";
import globalHelper from "./helper/globalHelper";
import './setupFaviconAndTitle';

setupAxios(axios);
globalHelper.setStore(store);

ReactDOM.render(
  <Provider store={store}>
    <App axios={axios}/>
  </Provider>,
  document.getElementById("root")
);

